import { styled as muiStyled } from '@mui/material'

export const HIWHeading = muiStyled('div')(
  ({ theme }) => `
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin-bottom: 20px;
    text-align: center;
    @media(min-width: 768px){
      font-size: 30px;
    }
`,
)
